module.exports = __webpack_public_path__ + "static/media/more500-icon.375afc2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/more500-icon.svg
// module id = 2875
// module chunks = 0